import Component from './signup_form.vue'
export default Component
